<template>
  <vue100vh style="position: fixed;width: 100%;">
  <div class="CSChatThai BGwhite">
    <v-toolbar style="background-color: white !important;">
      <v-btn icon @click="toPage()">
        <v-icon>chevron_left</v-icon>
      </v-btn>
      <v-toolbar-title>{{$t('ChatSide.forward')}}</v-toolbar-title>
    </v-toolbar>
    <v-layout column wrap>
    <v-card-text style="margin-top: 7px; margin-bottom:0vh; justify-content: center !important; color: rgb(74, 74, 74) !important;">
      <v-tabs centered fixed-tabs style="height: 20px;">
        <v-tabs-slider color="blue"></v-tabs-slider>
          <v-tab href="#tab-1" class="text-transform">{{$t('Dialog.forward.friend')}}</v-tab>
          <v-tab href="#tab-2" class="text-transform">{{$t('Dialog.forward.group')}}</v-tab>
          <!-- <v-tab href="#tab-3">แชท</v-tab> -->

          <v-tabs-items v-model="tabs" class="white elevation-1">
            <!-- tab friend -->
            <v-tab-item id="tab-1" style="height: calc(100vh - 128px);">
              <v-list dense style="padding-top: 0px;" class="layoutsearchweb">
                <v-container class="layoutsearchweb">
                  <v-layout row wrap  class="layoutsearchweb">
                    <v-flex xs12 xl12 md12 sm12 lg12>
                      <v-text-field append-icon="search" :label="$t('Dialog.group.searching')" solo clearable v-model="search" style="color: white !important;"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 xl12 md12 sm12 lg12 style="max-height: calc(100vh - 260px); overflow-y: scroll;" class="scroll-y">
                      <b slot="header" class="CSChatThai" v-if="FilterFriendList.length != 0">{{$t('Dialog.forward.friend')}} ({{FilterFriendList.length}})</b>
                    <b slot="header" class="CSChatThai" v-else>{{$t('Dialog.forward.friend')}}</b>
                    <v-list subheader style="padding-left: 0px; padding-right: 0px; background-color: #fff !important; width: 100%;" v-if="!ProgressListFriend">
                      <template v-for="(item, index) in FilterFriendList" v-if="FilterFriendList.length != 0">
                        <div avatar style="padding-top: 0px;cursor: pointer;">
                          <v-list-tile avatar>
                            <v-list-tile-avatar style="padding-left: 1vw;margin-right: 1vw;">
                              <img v-if="item.profilepicture" :src="item.profilepicture" class="alligator-turtle" >
                              <img v-else-if="item.type === 'government'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                              <img v-else-if="item.type === 'business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                              <img v-else-if="item.type === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
                              <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
                            </v-list-tile-avatar>

                            <v-list-tile-content style="margin-right: 0vw;padding-right: 1vw;">
                              <v-list-tile-title class="fontselect " style="font-size:13px;">
                                {{item.name}}
                              </v-list-tile-title>
                              <v-list-tile-sub-title class="fontselectchat ">
                                <span class='text--primary fontselectchat ' v-if="item.status !== ''" style="font-size: 11px!important;">
                                  {{item.status}}
                                </span>
                              </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                              <v-checkbox v-model="selectedfriend" :value="item"></v-checkbox>
                            </v-list-tile-action>
                          </v-list-tile>
                        </div>
                        <v-divider ></v-divider>
                      </template>
                    </v-list>
                    <div v-else>
                      <v-progress-linear :indeterminate="ProgressListFriend"></v-progress-linear>
                    </div>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-list>
            </v-tab-item>
            <!-- tab group -->
            <v-tab-item id="tab-2" style="height: calc(100vh - 128px);">
              <v-list dense style="padding-top: 0px;" class="layoutsearchweb">
                <v-container class="layoutsearchweb">
                  <v-layout row wrap  class="layoutsearchweb">
                    <v-flex xs12 xl12 md12 sm12 lg12>
                      <v-text-field append-icon="search" :label="$t('Dialog.forward.searchgroup')" solo clearable v-model="search" style="color: white !important;"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 xl12 md12 sm12 lg12 style="max-height: calc(100vh - 260px); overflow-y: scroll;" class="scroll-y">
                      <b slot="header" class="CSChatThai" v-if="FilterGroupList.length != 0">{{$t('Dialog.forward.group')}} ({{FilterGroupList.length}})</b>
                    <b slot="header" class="CSChatThai" v-else>{{$t('Dialog.forward.group')}}</b>
                    <v-list subheader style="padding-left: 0px; padding-right: 0px; background-color: #fff !important; width: 100%;" v-if="!ProgressListGroup">
                      <template v-for="(item, index) in FilterGroupList" v-if="FilterGroupList.length != 0">
                        <div avatar style="padding-top: 0px;cursor: pointer;">
                          <v-list-tile avatar>
                            <v-list-tile-avatar style="padding-left: 1vw;margin-right: 1vw;">
                              <img v-if="item.picture" :src="item.picture" class="alligator-turtle" >
                              <img v-else-if="item.type === 'government'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                              <img v-else-if="item.type === 'business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                              <img v-else-if="item.type === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
                              <img v-else-if="item.type === 'group'" src='/static/img/default_profile/group-white.png' class="alligator-turtle">
                              <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
                            </v-list-tile-avatar>

                            <v-list-tile-content style="margin-right: 0vw;padding-right: 1vw;">
                              <v-list-tile-title class="fontselect " style="font-size:13px;">
                                {{item.name}}
                              </v-list-tile-title>
                              <v-list-tile-sub-title class="fontselectchat ">
                                <span class='text--primary fontselectchat ' v-if="item.status !== ''" style="font-size: 11px!important;">
                                  {{item.status}}
                                </span>
                              </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                              <v-checkbox v-model="selectedfriend" :value="item"></v-checkbox>
                            </v-list-tile-action>
                          </v-list-tile>
                        </div>
                        <v-divider ></v-divider>
                      </template>
                    </v-list>
                    <div v-else>
                      <v-progress-linear :indeterminate="ProgressListGroup"></v-progress-linear>
                    </div>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-list>
            </v-tab-item>
            <!-- tab chat -->
            <!-- <v-tab-item id="tab-3" style="height: calc(100vh - 128px);">
              <v-list dense style="padding-top: 0px;" class="layoutsearchweb">
                <v-container class="layoutsearchweb">
                  <v-layout row wrap  class="layoutsearchweb">
                    <v-flex xs12 xl12 md12 sm12 lg12>
                      <v-text-field append-icon="search" label="ค้นหาแชท..." solo clearable v-model="search" style="color: white !important;"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 xl12 md12 sm12 lg12 style="max-height: calc(100vh - 260px); overflow-y: scroll;" class="scroll-y">
                      <b slot="header" class="CSChatThai" v-if="FilterChatList.length != 0">แชท ({{FilterChatList.length}})</b>
                    <b slot="header" class="CSChatThai" v-else>แชท</b>
                    <v-list subheader style="padding-left: 0px; padding-right: 0px; background-color: #fff !important; width: 100%;" v-if="!ProgressListChat">
                      <template v-for="(item, index) in FilterChatList" v-if="FilterChatList.length != 0">
                        <div avatar style="padding-top: 0px;cursor: pointer;">
                          <v-list-tile avatar>
                            <v-list-tile-avatar style="padding-left: 1vw;margin-right: 1vw;">
                              <img v-if="item.picture" :src="item.picture" class="alligator-turtle" >
                              <img v-else-if="item.type === 'government'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                              <img v-else-if="item.type === 'business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                              <img v-else-if="item.type === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
                              <img v-else-if="item.type === 'group'" src='/static/img/default_profile/group-white.png' class="alligator-turtle">
                              <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
                            </v-list-tile-avatar>

                            <v-list-tile-content style="margin-right: 0vw;padding-right: 1vw;">
                              <v-list-tile-title class="fontselect " style="font-size:13px;">
                                {{item.name}}
                              </v-list-tile-title>
                              <v-list-tile-sub-title class="fontselectchat ">
                                <span class='text--primary fontselectchat ' v-if="item.status !== ''" style="font-size: 11px!important;">
                                  {{item.status}}
                                </span>
                              </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                              <v-checkbox v-model="selectedfriend" :value="item"></v-checkbox>
                            </v-list-tile-action>
                          </v-list-tile>
                        </div>
                        <v-divider ></v-divider>
                      </template>
                    </v-list>
                    <div v-else>
                      <v-progress-linear :indeterminate="ProgressListChat"></v-progress-linear>
                    </div>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-list>
            </v-tab-item> -->
          </v-tabs-items>
      </v-tabs>
    </v-card-text>
    <div class="footer">
      <div class="scrolling-wrapper" >
        <v-chip close v-for="i in selectedfriend"  @input="removeListAddGroup(i)">
          <v-avatar >
            <img v-if="i.profilepicture" :src="i.profilepicture" :alt="i.tokenroom" class="alligator-turtle">
            <img v-else-if="i.picture" :src="i.picture" :alt="i.tokenroom" class="alligator-turtle">
            <img v-else-if="i.type === 'business'" src='/static/img/default_profile/business-white.png' :alt="i.tokenroom">
            <img v-else-if="i.type === 'government'" src='/static/img/default_profile/business-white.png' :alt="i.tokenroom">
            <img v-else-if="i.type === 'bot'" src='/static/img/default_profile/bot-white.png' :alt="i.tokenroom">
            <img v-else-if="i.type === 'group'" src='/static/img/default_profile/group-white.png' :alt="i.tokenroom">
            <img v-else src='/static/img/default_profile/man-white.png' :alt="i.tokenroom">
          </v-avatar>
          <span class="text2">{{i.name}}</span>
        </v-chip>
      </div>
      <v-flex xs12 sm12 md12>
        <v-layout justify-center align-center row wrap v-if="selectedfriend.length === 0" style="margin-top: 15px;">
          <v-btn disabled class="btncreategroup text-transform" small round>
            {{$t('AnswerQuestion.forward')}}
          </v-btn>
          <v-btn class="btncanclegroup text-transform" small round @click="closeSeleted()">
            {{$t('AnswerQuestion.cancel')}}
          </v-btn>
        </v-layout>
        <v-layout justify-center align-center row wrap v-else>
          <v-btn class="btncreategroup text-transform" small round @click="sendforward()">
            {{$t('AnswerQuestion.forward')}}
          </v-btn>
          <v-btn class="btncanclegroup text-transform" small round @click="closeSeleted()">
            {{$t('AnswerQuestion.cancel')}}
          </v-btn>
        </v-layout>
      </v-flex>
    </div>
  </v-layout>
  </div>
</vue100vh>
</template>
<script>
import { sync } from 'vuex-pathify'
import { Decode } from '@/services'
import vue100vh from 'vue-100vh'
var _ = require('lodash')
export default {
  data: () => ({
    tabs: '',
    selectedgroup: [],
    selectedfriend: [],
    listblock: [],
    token: '',
    search: '',
    listfriend: [],
    listgroup: [],
    listchat: [],
    ProgressListFriend: false,
    ProgressListGroup: false,
    ProgressListChat: false,
    listtokenroom: [],
    chips: []
  }),
  components: {
    vue100vh
  },
  methods: {
    closeSeleted () {
      this.selectedfriend = []
    },
    sendforward () {
      for (var i = 0; i < this.selectedfriend.length; i++) {
        this.listtokenroom[i] = this.selectedfriend[i].tokenroom
      }
      // console.log(this.tokenmsgforward)
      // console.log(this.listtokenroom)
      if (this.tokenmsgforward.length !== 0) {
        this.axios.post(process.env.APIimage + '/forward_file_message', {list_tokenroom: this.listtokenroom, tokenuser: this.token, list_tokenmessage: this.tokenmsgforward}).then((response) => {
          // console.log(response.data)
          if (response.data['status'] === 'success') {
            this.$swal(
              '',
              this.$t('Alert.Success.success'),
              'success'
            )
            this.tokenmsgforward = []
            this.listtokenroom = []
            this.selectedfriend = []
            this.toPage()
            // this.$router.push('/mobile/homepage/')
            // for (var i = 0; i < response.data.data.length; i++) {
            //   var tokenroomforward = ''
            //   tokenroomforward = response.data.data[0].tokenroom
            // }
            // this.$router.push('/mobile/room/' + tokenroomforward)
          } else {
            this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'warnning')
          }
        }, () => {
          this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'warnning')
        })
      } else {
        this.$swal('', this.$t('Alert.Fail.forward.selectMessage'), 'warning')
      }
    },
    removeListAddGroup (item) {
      this.selectedfriend.splice(this.selectedfriend.indexOf(item), 1)
    },
    toPage () {
      this.$router.push('/mobile/room/' + this.$route.params.roomid)
    },
    getlistfriend () {
      this.ProgressListFriend = true
      this.axios.post(process.env.APIgo_api + '/v1/get-list-friend', {tokenuser: this.token}).then((response) => {
        if (response.data.status === 'success') {
          this.ProgressListFriend = false
          this.listfriend = response.data['list_friend']
          // console.log(this.listfriend)
        } else {
          this.ProgressListFriend = false
        }
      })
    },
    getlistgroup () {
      this.ProgressListGroup = true
      this.axios.post(process.env.APIgo_api + '/v1/get-list-group', {tokenuser: this.token}).then((response) => {
        if (response.data.status === 'success') {
          this.ProgressListGroup = false
          this.listgroup = response.data['list_active_group']
          // console.log(this.listgroup)
        } else {
          this.ProgressListGroup = false
        }
      })
    },
    getlistchat () {
      this.ProgressListChat = true
      this.axios.post(process.env.APImanage + '/web/getlistchat', {tokenuser: this.token}).then((response) => {
        if (response.data.status === 'success') {
          this.ProgressListChat = false
          this.listchat = response.data['listchat']
          // console.log(this.listchat)
        } else {
          this.ProgressListChat = false
        }
      })
    }
  },
  computed: {
    FilterFriendList () {
      if (this.search !== '' && this.search !== null) {
        return this.listfriend.filter(post => {
          return post.name.toLowerCase().includes(this.search.toLowerCase())
        })
      } else {
        return this.listfriend
      }
    },
    FilterGroupList () {
      if (this.search !== '' && this.search !== null) {
        return this.listgroup.filter(post => {
          return post.name.toLowerCase().includes(this.search.toLowerCase())
        })
      } else {
        return this.listgroup
      }
    },
    FilterChatList () {
      if (this.search !== '' && this.search !== null) {
        return this.listchat.filter(post => {
          return post.name.toLowerCase().includes(this.search.toLowerCase())
        })
      } else {
        return this.listchat
      }
    },
    ...sync('*')
  },
  watch: {
    // selectedmessage (data) {
    //   this.listtokenmsg = data
    // },
    selectedfriend () {
      if (this.selectedfriend.length > 5) {
        this.$swal(
          '',
          this.$t('Alert.Fail.forward.maxChatRoom'),
          'error'
        )
        _.pullAt(this.selectedfriend, [5])
      }
    }
  },
  created () {
    var decoded = JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
    this.getlistchat()
    this.getlistfriend()
    this.getlistgroup()
  }
}
</script>
<style type="text/css" scoped>
.text-transform {
  text-transform: none;
}
.btncreategroup {
  color: white !important;
  background-color: #2562af !important;
}
.btncanclegroup {
  color: #1b232db3 !important;
  background-color: #cacacae3 !important;
}
.scrolling-wrapper {
  display: flex;
  overflow-x: auto;
}
.scrolling-wrapper::-webkit-scrollbar {
  height: 4px;
}
.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: rgba(0, 0, 0, .1);
}
.text2 {
  white-space: nowrap;
  width: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
}
>>>.v-chip .v-chip__content {
  border-radius: 28px;
  cursor: default;
  height: 27px;
  justify-content: space-between;
  padding: 0 12px;
  white-space: nowrap;
  z-index: 1;
}
>>>.v-text-field.v-text-field--solo .v-input__control {
  min-height: 35px;
  padding: 0;
}
>>>.v-tabs__container .v-tabs__container--centered .v-tabs__container--fixed-tabs {
  height: 20px !important;
}
>>>.v-tabs__container {
  flex: 1 0 auto;
  display: flex;
  height: 40px;
  list-style-type: none;
  transition: -webkit-transform .6s cubic-bezier(.86,0,.07,1);
  transition: transform .6s cubic-bezier(.86,0,.07,1);
  transition: transform .6s cubic-bezier(.86,0,.07,1),-webkit-transform .6s cubic-bezier(.86,0,.07,1);
  white-space: nowrap;
  position: relative;
}
.footer {
  border-width: thin;
  border-top-style: solid;
  border-color: #80808099;
  height: 70px;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: #ffffff;
  color: #c8c8c8c9;
  text-align: center;
}
.footerdis {
  border-width: thin;
  border-top-style: solid;
  border-color: #80808099;
  height: 70px;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: #ffffff;
  color: #c8c8c8c9;
  text-align: center;
}
>>>.v-card__text {
  padding: 0px;
}
/*>>>.v-input__slot {
  border-width: thin !important;
  border-style: solid !important;
  border-radius: 20px !important;
  border-color: #808080a6 !important;
  box-shadow: none !important;
}*/
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) .v-input__slot {
  /*box-shadow: none;*/
  border-width: thin !important;
  border-style: solid !important;
  border-radius: 20px !important;
  border-color: #808080a6 !important;
  box-shadow: none !important;
}
.borderlistfriend {
  border-width: thin !important;
  border-style: solid !important;
  border-radius: 20px !important;
  border-color: #808080a6 !important;
  box-shadow: none !important;
}
.alligator-turtle {
  object-fit: cover;
  object-position: 50% 0;
}
>>>.v-toolbar {
  /* box-shadow: none; */
  box-shadow: 0 2px 0px -1px hsla(0,0%,100%,.12), 0 0px 5px 0 rgba(0,0,0,.14), 0 1px 10px 0 rgba(0,0,0,.12) !important;
}
.Kanit{
  font-family: 'Kanit', sans-serif !important;
}
.edit {
  font-weight: 100;
}
.inputWrapper {
    height: 32px;
    width: 90px;
    overflow: hidden;
    position: relative;
    cursor: pointer;
}
.img {
  display: block;
  max-width:230px;
  max-height:95px;
  width: auto;
  height: auto;
}
.dialog .dialog--active .dialog--persistent {
  max-height: 107vh;
  overflow: hidden;
}
.card__text {
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 16px;
  overflow: hidden;
}
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
.textbusiness {
  margin-top: 1vh;
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
  /*width: 300px;*/
}
input[type=textprofile] {

    width: 100%;
    box-sizing: border-box;
    border: 2px solid #ccc;
    border-radius: 4px;
    font-size: 16px;
    background-color: white;
    /*background-image: url('../assets/image/group.png');*/
    background-position: 10px 10px;
    background-repeat: no-repeat;
    padding: 10px 10px 10px 10px;
    -webkit-transition: width 0.4s ease-in-out;
    transition: width 0.4s ease-in-out;
}
input[type=textprofile]:disabled {
    background: #cac9c9;
}
.EndpointUrl:hover .urlcopymessageapi {
  display: inline !important;
}
.urlcopymessageapi {
  display: none !important;
}
.EndpointUrl {
  display: block;
  /*color: #6D7D8D;*/
}
.header {
    display: block;
    font-size: 1.17em;
    -webkit-margin-before: 1em;
    -webkit-margin-after: 1em;
    -webkit-margin-start: 0px;
    -webkit-margin-end: 0px;
    margin: 40px 0 20px;
    padding-left: 20px;
    line-height: 1.3;
    font-weight: bold;
    font-size: 16px;
    position: relative;
    color: black !important;
}
.header::before {
    content: "";
    display: inline-block;
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    left: 0;
    width: 0;
    height: 32px;
    border-left: 4px solid #1a76d2;
}
.Setting {
    margin-bottom: 2vh;
}
.SettingBlock {
    padding: 30px 20px;
    border-top: 1px solid #DEE5EC;
}
.SettingBlock > :last-child {
    margin-bottom: 0;
}
.List_Register {
    margin-bottom: 32px;
    box-sizing: border-box;
}
.List_Register .List_item:last-child {
    border-bottom: none;
}
.List_Register .List_item {
    display: -webkit-flex;
    display: flex;
    padding: 0;
}
.List_Register .List_item:last-child .List_item_header {
    width: 200px;
}
.SettingTtl {
    margin-bottom: 8px;
    font-weight: bold;
    white-space: nowrap;
    color: black !important;
}
.md91SettingImg {
    padding-bottom: 12px;
    line-height: 1;
}
.SettingImgWrap {
    display: inline-block;
    position: relative;
    border-radius: 40px;
    overflow: hidden;
}
.SettingImgMask {
   position: relative;
    width: 160px;
    height: 160px;
    overflow: hidden;
    border-radius: 40px;
}

.SettingImgBtn {
    display: block;
    overflow: hidden;
    position: absolute;
    bottom: -20px;
    right: -20px;
    line-height: 1;
    width: 40px;
    height: 30px;
    bottom: 0;
    left: 0;
    line-height: 30px;
    width: 100%;
    text-align: center;
    cursor: pointer;
    color: #fff;
    background: rgba(0, 0, 0, .5);
}

.SettingImgBtn:hover {
    display: block;
    overflow: hidden;
    position: absolute;
    bottom: -20px;
    right: -20px;
    line-height: 1;
    width: 40px;
    height: 50%;
    bottom: 0;
    left: 0;
    line-height: 30px;
    width: 100%;
    text-align: center;
    cursor: pointer;
    color: #fff;
    background: rgba(0, 0, 0, .75);
}
.SettingImgInput {
    position: absolute;
    left: -9999px;
}
.EditAreaNote {
    margin: 8px 0 0;
    font-size: 13px;
    color: #BEC8D2;
    font-size: 12px;
}
.EditArea {
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    -webkit-align-items: center;
    align-items: center;
}
.BreakWord {
    white-space: pre-wrap;
    word-break: break-all;
    word-break: break-word;
    word-wrap: break-word;
}
.EditAreaCont {
    width: 100%;
    padding-right: 1em;
    box-sizing: border-box;
}
.SettingQr {
    display: -webkit-flex;
    display: flex;
}
.SettingQrImg {
    margin: 0 50px;
    position: relative;
}
.SettingQrNote {
    margin-bottom: 0;
    font-size: 13px;
}
.buttonedit {
  color: ghostwhite;
  border-radius: 4px;
  background-color: #2562af !important;
  border: solid 1px #2562af !important;
  -webkit-box-sizing: border-box !important;
  box-sizing: border-box !important;
  margin-right: 0 !important;
  text-align: center;
  font-weight: 400 !important;
  text-transform: none;
}
.buttoncancel {
  color: black;
  border-radius: 4px;
  background-color: #c1c1c196 !important;
  border: solid 1px #c1c1c1 !important;
  -webkit-box-sizing: border-box !important;
  box-sizing: border-box !important;
  margin-right: 0 !important;
  text-align: center;
  font-weight: 400 !important;
  text-transform: none;
}
.EditAreaContFlex {
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    -webkit-align-items: center;
    align-items: center;
}

.InputEdit {
    width: 100%;
    padding: 10px 15px;
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid #d2d8dd;
    border-radius: 4px;
}
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
.BGwhite {
  background-color: white !important;
}
/*.avatarpicBis:hover .overlay {
  opacity: 1;

}*/
</style>



// WEBPACK FOOTER //
// src/components/mobile/manage/Forwardmessage.vue